import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectPortfolios() {
      return getState().portfolios;
    },
    isRetrieveProjectPortfoliosRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveProjectPortfoliosRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveProjectPortfoliosRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
